export default [
  {
    path: '/online-checkin-share/:localizator',
    name: 'foravila-online-checkin',
    component: () => import('@/views/foravila/bookings/check-in/DettachedCheckin.vue'),
    meta: {
      layout: 'full',
      resource: 'Checkin'
    },
  },
]